'use client';

import { useState } from 'react';
import { Repeat } from 'lucide-react';
import { Button } from '@/atoms/Button/Button';
import { useRequireAuth } from '@/hooks/useRequireAuth/useRequireAuth';
import { cn } from '@/libs/utils/utils';
import { DialogNewPost } from '@/organisms/DialogNewPost/DialogNewPost';
import { RESOURCE_ACTION_BUTTON_CLASS_NAME } from './ResourceActions.constants';

/**
 * "Post about this": opens the new-post composer with the external resource's link as its text.
 * As the first link of a new post it is selected as the post's embed, so the composer shows its
 * card with the X that removes it. Signed out, it asks to sign in. Without a web link (`null`: a
 * resource known only as `isbn:`, `doi:`, ...) it is disabled, as the composer embeds web links only.
 */
export function ResourcePostButton({ uri }: { uri: string | null }) {
  const { requireAuth } = useRequireAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className={cn(RESOURCE_ACTION_BUTTON_CLASS_NAME, 'w-10')}
        aria-label="Post about this"
        title="Post about this"
        disabled={!uri}
        onClick={() => requireAuth(() => setOpen(true))}
        data-testid="resource-post-button"
      >
        <Repeat aria-hidden="true" />
      </Button>
      {open && uri && <DialogNewPost open={open} onOpenChangeAction={setOpen} initialContent={uri} />}
    </>
  );
}
